import { removeAccountOrganizations } from "../../graphql/organizations/zone";
import { addOrganizationDevices } from "../../graphql/organizations/index";
import { UPDATE_BILLING_ACCOUNT } from "../renters/graphql";
import useAlerts from "@tod-ui/composables/useAlerts";

export default function useEndService() {
  const { addAlert } = useAlerts();

  async function removeDeviceAndUnassignUnit(
    apolloClient,
    unit,
    billingAccountId,
    facilityId,
    refetchQueries = []
  ) {
    const deviceIds = (unit.devices || []).map((device) => device.id);
    try {
      await apolloClient.mutate({
        mutation: removeAccountOrganizations,
        variables: {
          billingAccountId,
          organizationIds: [unit.id],
          moveOutReason: deviceIds.length > 0 ? "device_removed" : undefined,
          retainRecord: true,
        },
        refetchQueries,
      });
    } catch (error) {
      addAlert({
        type: "error",
        message: `There was an error removing Smart Unit ${unit.name}`,
      });
      return;
    }

    if (deviceIds.length === 0) {
      addAlert({
        type: "success",
        message: `Smart Unit ${unit.name} was ended successfully`,
        timeout: 15,
      });
      return;
    }

    try {
      await apolloClient.mutate({
        mutation: addOrganizationDevices,
        variables: { id: facilityId, devices: deviceIds },
        refetchQueries,
      });
      addAlert({
        type: "success",
        message: `Smart Unit ${unit.name} was ended successfully and its device(s) returned to facility inventory`,
        timeout: 15,
      });
    } catch (error) {
      addAlert({
        type: "error",
        message: `Smart Unit ${unit.name} was unassigned, but its device(s) could not be returned to facility inventory. Please retry from Manage Devices or contact support.`,
        timeout: 30,
      });
    }
  }

  async function endServiceForAccount(
    apolloClient,
    billingAccount,
    cause,
    refetchQueries = []
  ) {
    try {
      await apolloClient.mutate({
        mutation: UPDATE_BILLING_ACCOUNT,
        variables: {
          id: billingAccount.id,
          name: billingAccount.name,
          type: billingAccount.type,
          status: "ended_service",
          cause:
            cause ||
            "Ended service for the renter, but leaving device(s) in unit(s)",
        },
        refetchQueries,
      });
      addAlert({
        type: "success",
        message: `SD service for the renter ${billingAccount.name} was ended successfully`,
        timeout: 15,
      });
    } catch (error) {
      addAlert({
        type: "error",
        message: `There was an error ending SD service for ${billingAccount.name}`,
      });
    }
  }

  return { removeDeviceAndUnassignUnit, endServiceForAccount };
}
